import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'franbase-gradient-btn',
  standalone: true,
  imports: [
    CommonModule,
    NzButtonModule,
    RouterModule,
  ],
  templateUrl: './gradient-btn.component.html',
  styleUrls: ['./gradient-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradientBtnComponent {
  @Input() type: 'button' | 'link' = 'button';
  @Input() size: 'small' | 'default' | 'large' = 'default';
  @Input() link = '';
  @Input() btnClass = '';
  @Input() parentBg = 'bg-white';
  @Input() btnTextColor = 'text-primary-500';
  @Input() btnTextHoverColor = 'text-white';
  @Input() borderColor: 'btn-filled' | string = 'btn-filled';
  router = inject(Router);
}
